import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import FormInternManual from "../Components/FormInternManual";

const InternManual = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const req_id = searchParams.get("req_id");
  const profile = useSelector((state) => state.profileReducer.profile);
  console.log({ profile });

  // useEffect(() => {
  //   if (
  //     !profile ||
  //     (profile.m_role !== "staff" && profile.id !== req_id?.slice(0, 8))
  //   ) {
  //     navigate("/");
  //   }
  // }, [profile]);

  return (
    <div>
      <FormInternManual internRequestId={req_id} />
    </div>
  );
};

export default InternManual;
